import emptyChannelListImg from 'assets/images/emptyChannelList.png';

export const getCurrentChannelLogo = (isLogoPlaceholder: boolean, currentChannelLogo: string | undefined) =>
  isLogoPlaceholder ? emptyChannelListImg : currentChannelLogo;
